<template>
  <div style="min-height: 400px">
    <ScreenSelect
      @changeTimeRange="selectTime"
      :typeOptions="typeOptions"
      @changeType="changeType"
    />
    <a-table
      :columns="columns"
      :data-source="tableData"
      :pagination="pagination"
      :row-key="record => record.pkId"
      :loading="loading"
      @change="handlePagination"
      :transformCellText="({ text }) => (text === -1 ? '-' : text || '-')"
    />
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import { deviceAlarmList } from '@/services/device-manage/device';
import { deviceTypeEnum } from '@/enum/device';
import ScreenSelect from '@/views/safety-device/component/screen-select';
import { deviceTypeList } from '@/services/device-manage/device-detail';

@Component({
  components: {
    ScreenSelect,
  },
})
export default class ScrewWarning extends Vue {
  @Prop({ type: String, default: '' }) pageType;
  @Prop({ type: String, default: '' }) deviceId;

  get columns() {
    return [
      {
        dataIndex: 'index',
        customRender: (text, record, index) => (
          <span>{(this.pagination.current - 1) * 10 + index + 1}</span>
        ),
        width: 80,
        title: this.$t('safety.index'),
        align: 'center',
      },
      {
        align: 'left',
        title: this.$t('safety.time'),
        dataIndex: 'alarmTime',
        width: 180,
        customRender: txt =>
          txt ? this.dayjs(txt).format('YYYY-MM-DD HH:mm:ss') : '-',
      },
      {
        align: 'left',
        title: '监测点',
        dataIndex: 'positionId',
        ellipsis: true,
      },
      {
        align: 'left',
        title: '事件类型',
        // dataIndex: 'subType',
        dataIndex: 'subTypeName',
        ellipsis: true,
        // customRender: txt => (txt ? this.changeSubType(txt) : ''),
      },
    ];
  }
  changeSubType(val) {
    const typeList = this.typeOptions;
    const idx = typeList.findIndex(v => v.value === val);
    return typeList[idx].label;
  }
  pagination = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '30', '40'],
    showTotal: total => `${total} ${this.$t('common.total')}`,
  };
  tableData = [];
  mounted() {
    this.getTableList();
    this.getTypeList();
  }
  typeOptions = [];
  async getTypeList() {
    try {
      this.typeOptions = await deviceTypeList(this.deviceGroup);
    } catch {
      return false;
    }
  }
  get deviceGroup() {
    return deviceTypeEnum[this.pageType].deviceGroup;
  }
  rangeTime = {
    startTime: '',
    endTime: '',
  };
  selectTime(t) {
    if (t && t.startTime) {
      this.rangeTime.startTime = t.startTime;
      this.rangeTime.endTime = t.endTime;
    } else {
      this.rangeTime = {
        startTime: '',
        endTime: '',
      };
    }
    this.pagination.current = 1;
    this.getTableList();
  }
  selectType = {
    type: '',
    value: '',
  };
  changeType(v) {
    if (v && v.value !== 'all') {
      this.selectType = v;
    } else {
      this.selectType = {
        type: '',
        value: '',
      };
    }
    this.pagination.current = 1;
    this.getTableList();
  }
  loading = false;
  async getTableList() {
    const params = {
      deviceId: this.deviceId,
      query: {
        current: this.pagination.current,
        size: this.pagination.pageSize,
      },
      deviceGroup: this.deviceGroup,
    };
    if (this.rangeTime.startTime) {
      params.startTime = this.rangeTime.startTime;
      params.endTime = this.rangeTime.endTime;
    }
    if (this.selectType.value) {
      params.type = this.selectType.type;
      params.subType = this.selectType.value;
    }
    this.loading = true;
    try {
      const { records, current, size, total } = await deviceAlarmList(
        params,
        this.deviceGroup,
      );
      this.tableData = records;
      this.pagination.current = current;
      this.pagination.pageSize = size;
      this.pagination.total = total;
      this.loading = false;
    } catch {
      this.loading = false;
      return false;
    }
  }
  handlePagination(data) {
    this.pagination = data;
    this.getTableList();
  }
}
</script>

<style></style>
